<template>

  <div id="app">

    <div class="iarc_layout page-template show-bottom-menu iarc-site-www custom-home-page homepage-iarc">
      
      <div class="ribbon ribbon-top-right" v-if="( this.$store.state.env.VUE_APP_ENV == 'dev' || is_nanga == true ) && this.$store.state.env.VUE_APP_VERSION!=''">
        <span>v{{ this.$store.state.env.VUE_APP_VERSION }}</span>
      </div>

      <!-- home page clean version to put into nanga first -->
      <NavMobile 
        v-bind:menus="this.website_menu" 
        v-bind:website_logo="this.website_logo"
        v-bind:website_mobile_logo="this.website_mobile_logo"
        v-bind:website_url="this.website_url" 
        v-bind:website_title="this.website_title"
        />

      <!-- custom HEADER -->
      <header id="header" class="header">
        
          <div class="header-bg">
            <div class="header-container">
              <div class="d-flex header-top header-bar__top-line align-items-center">
                <div class="header-logo align-content-center">
                    <a class="logo" href="https://www.the-iacr.net" title="IARC">
                      <img :src="logo" id="logo-iacr" title="IACR">
                    </a>
                </div>
                <div class="site-name-wrapper d-md-flex">
                 
                </div>
                <div class="header-lang d-lg-flex">
                    <div class="btn-newsletter">
                      <a href="https://iacr.s2.yapla.com/en/member-section/authentication/" target="_blank" class="subscribe-button">Members Portal</a>
                    </div>
                    <div class="btn-donations-custom">
                      <a href="https://IACR.s2.yapla.com/en/member-section" class="support-button" target="_blank">Become a member</a>
                    </div>
                </div>
                <div class="burger"></div>
              </div>
            </div>
          </div><!-- End header bg -->

          <Nav 
            v-bind:menus="website_menu"
            v-bind:website_logo="logo"
            v-bind:website_title="'IACR'"
            />

          <!--<div class="header-bar">
            <Tabs v-bind:tabs="[
              { name : 'Tab 1' , hash : '#tab1' } , 
              { name : 'Tab 2' , hash : '#tab2' } , 
              { name : 'Tab 1' , hash : '#tab3' } 
            ]" />
          </div>-->

      </header>

      <router-view :key="$route.path" />

      <!-- custom HEADER -->
      <Footer/>

    </div>

  </div>

</template>

<script>
import TheLanguageSwitcher from '@/csu-vue-components/components/TheLanguageSwitcher'
import IarcFooter from '@/csu-vue-components/components/IarcFooter.vue'
import TheMobileNavigation from '@/csu-vue-components/components/TheMobileNavigation'
import TheNavigation from '@/csu-vue-components/components/TheNavigation'
import Mobile from '@/csu-vue-components/components/Mobile'
import Theming from '@/components/Theming'
import Nav from '@/csu-vue-components/themes/iarc_new/Nav.vue'
import NavMobile from '@/csu-vue-components/themes/iarc_new/NavMobileIACR.vue'
import Tabs from '@/csu-vue-components/themes/iarc_new/Tabs'

import Footer from '@/csu-vue-components/themes/iarc_new/Footer.vue'

import LayoutIarc from '@/csu-vue-components/themes/iarc_new/Layout.vue'
import Constant from './const.js' 


export default {
  name: 'AppNewIARC',
  components: {
    Nav , 
    Tabs , 
    TheNavigation , 
    IarcFooter, 
    Footer , 
    NavMobile , 
    Mobile, 
    TheMobileNavigation , 
    Theming 
  },
  props : {
    website_hide_gco : { type : Boolean , default : false },
    website_logo : { type : String } , 
    website_mobile_logo : { type : String } , 
    website_url : { type : String } , 
    website_title : { type : String }
  },
  created(){
    this.$store.commit('setEnv',process.env) ; 
    window.addEventListener("resize", this.setGraphicSizes );
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {

    this.findRoute();

    this.logo = require(`@/subsites/iacr/assets/img/IACR_logo_white.png`) ; 
  
    /* console.info({
      "$store volume" : this.$store.state.volume ,
      "router" : this.$route , 
      "process" : process.env , 
      "constant" : Constant
    }) ;*/

    if ( this.$route.params != undefined && this.$route.params.volume != undefined ){

      
      this.$store.commit('setVolume',this.$route.params.volume) ; 
    }

    if ( this.$router.currentRoute.path == '/standards/law') document.location.href = '/en/standards/law' ; 

  },
  data: function(){
    return {
        data_version : Constant.data_version , 
        route : 'home' ,
        public_path : `/${Constant.publicPath}/`,
        class_app : '' , 
        window: {
            width: 0,
            height: 0
        },
        logo : '',
        website_menu : this.$store.state.const.navigation ,
        is_nanga: false
    } 
  },
  methods : {

    /**
    * Find route
    */
    findRoute : function(){
      let uri     = window.location.pathname.split('/') ; 
      this.route = ( uri[uri.length-1].length > 2 ) ? uri[uri.length-1] : '' ;
      // console.info("this.route",this.route) ;  
    
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.$store.commit('setWindow',this.window) ; 
    },
    /**
    * Control size of .graphic depending on #container-filters
    * @param(no param)
    */
    setGraphicSizes_ : function(){
      // to change in a longer term, specify container col-md-9 differently
      let window_width_container = $(window).width() ;
      //$('.page.dataviz .page_content .col-md-9').width() ; // $('.graphic').width() ; 

      // console.log("graphic_width_container",graphic_width_container) ; 
      let adaptive_w = window_width_container-(110+$('.filters').width()+45) ; // sub menu + filters 
      $('.graphic').css('width',adaptive_w) ; 
    }
  }, 
  watch:{ 
      $route : function(to){
        if ( to.name != "home") 
          this.route = to.name ; 
        else
          this.findRoute();
      }
  }
}
</script>

<style lang="scss">

$bg_color: #0b80b7 ; 
$blue: #0b80b7 ; 

// Import from master-IARC new template : see (style.css to see import or import directly style.css)
// $font_family : "Nunito Sans", sans-serif;
$font_family : "Nunito Sans", sans-serif;

h1,h2,h3,h4,h5,p,div,article,header,footer,a,span,label,ul,li{
  font-family: $font_family !important ;
}

/*p{
  font-weight: 300 ; 
}

strong{
  font-weight: 300 !important ; 
}*/

@import '../../csu-vue-components/themes/iarc_new/assets/_variables.scss' ;

$blue : red ; 
$peach : green ; 
$green : #006D77;
$dark_blue:#0D3B66 ;

@import '../../csu-vue-components/themes/iarc_new/assets/bootstrap.v5.2.min.css' ;

@import '../../csu-vue-components/themes/iarc_new/assets/header-vertical.css' ;
@import '../../csu-vue-components/themes/iarc_new/assets/header-home-page.css' ;
@import '../../csu-vue-components/themes/iarc_new/assets/responsive.css' ;
@import '../../csu-vue-components/themes/iarc_new/assets/print.css' ;
@import '../../csu-vue-components/themes/iarc_new/assets/new-design.css' ;

@import '../../csu-vue-components/themes/iarc_new/assets/css/icomoon.css' ;
@import '../../csu-vue-components/themes/iarc_new/assets/graphic.scss' ; 
@import '../../csu-vue-components/themes/iarc_new/assets/sub-menu.scss' ; 

@import '../../csu-vue-components/themes/iarc_new/assets/base-new.css' ;
@import '../../csu-vue-components/themes/iarc_new/assets/ribon.scss' ;

// overide color #006D77
#header-menu{
  background-color: #0D3B66 ; 
}

#header .header-top .header-lang-donate,
#header .header-top .btn-donations-custom a,
#header .header-bar .header-lang-donate,
#header .header-bar .btn-donations-custom a,
#header .header-menu-search .btn-donations-custom,
body#iacr_website #app #footer{
  background: #006D77 !important;
  background-color: #006D77!important;
}

#header .header-top .subscribe-button, #header .header-bar .subscribe-button{
  background-color: #0D3B66
}

#footer .footer-top{
  background: #0D3B66 !important;
}

#header .header-bar__top-line .subscribe-button, #header .header-bar__top-line .support-button{
  border-color: #0D3B66
}

body#iacr_website{
  #dataviz_landing .block_dataviz{
    background-color: #0D3B66
  }

  .page h2,
    form fieldset h4,
    form fieldset.container_populations a.emptyPopButton i{
      color: #006D77 !important;
    }

    .follow .content ul.social li a i,
    ul.footer_links li i{
      color: #006D77 !important;
    }

    #container-filters .filters .radios_toggle label, 
    #container-filters .filters .checkbox_toggle label,
    .title_l1,.title_l2,
    .sub-menu-tabs .nav-tabs .nav-link.active, .sub-menu-tabs .nav-tabs .nav-item.show .nav-link{
      color: $dark_blue ;
    }

    /*.nav-tabs .nav-link.active{
      color: $dark_blue !important;
    }*/

    .nav-tabs .nav-link{
      color: #006D77 !important;
    }

    #table-container{
      .nav-tabs .nav-link{
        padding: 0.5rem 15px;
      }

      .nav-tabs .nav-link.active{
        color: #ffffff !important;
      }

    }
    

    #container-filters .filters .radios_toggle input[type=radio]:checked + label:not(.volume_label), #container-filters .filters .radios_toggle input[type=checkbox]:checked + label:not(.volume_label), #container-filters .filters .checkbox_toggle input[type=radio]:checked + label:not(.volume_label), #container-filters .filters .checkbox_toggle input[type=checkbox]:checked + label:not(.volume_label), form .multiselect__tag, form .vue-slider-process, table.datatable tr th, #table-container .nav-tabs .nav-link.active, #table-container .nav-tabs .nav-item.show .nav-link, ul.sub-menu li a.router-link-active, .radios_buttons input[type=radio]:checked + label:not(.volume_label), .radios_buttons input[type=checkbox]:checked + label:not(.volume_label), .radios_toggle label.checked{
      background-color: #0D3B66 !important;
    }

}

/* Custom additional css */
body{
  
  overflow-x: hidden;

  &.long-read {

    header#header{
      position: fixed;
      width: 100%;
    }
    main{

    }
  }
}

.left-menu-container {
  top: 280px;
}

.nav-tabs .nav-item{
 list-style-type: none !important;  
 margin-left: 0 ;
 
}

.color_blue{
  color: $color_dark_blue !important; 
}

.color_peach{
  color: $color_peach !important ; 
}

body.vertical-scroll-theme {
  main{
    top: 0px!important;
  }
}


body.long-read main#main article{

  a {
    color: #006D77;
    white-space: normal;   /* allows text to wrap to multiple lines */
    word-wrap: break-word; /* breaks long words if needed */
    text-decoration: none;
    text-underline-offset: 7px;
    display: inline;
    &:hover{
      color: #006D77 ; 
    }
  }
}

a.btn_donation{
  display: block;
  background-color: #006D77;
  color: #fff !important;
  padding: 10px 22px;
  margin: auto;
  text-align: center;
  font-size: 16px;
  width: 230px;
  border-radius: 25px;
  font-weight: 700;
  text-decoration: none !important; 
}

.page.page_volume{
  position: relative ;
  margin-top: 70px ;
}

img.img-left{
  max-height: 250px ; 
  margin: 5px 20px 0 0 ;
}

.tabs_dataviz,.tab_factsheets{

  ul.nav.nav-tabs{
    
    li.nav-item{
      a.nav-link{
        padding: 10px 20px ;
      }
    }
  }

  .group_blocks{
    padding: 0px 20px 0px 20px ;
    /*border: solid 1px #dee2e6;
    border-top: none ; */
    margin: 0 0px;
  }

  .tab-content > .active{
    border: solid 1px #dee2e6;
    border-top: none ;
  }

}


.main-menu {
  .header-menu-links{
    .menu-item:first-child{
      margin-left: 0px !important;
      a{
        margin-left: 0px;
      }
    }
    .menu-item{
      margin-right: 30px;
    }
  }

  h2{
    line-height: 38px;
    font-weight: bold;
    text-transform: none;
    color: #2b3256;
  }
}

@media(min-width: 992px) {
    .full-width {
        padding:0 105px !important;
    }
}

body.body-no-tabs{
  .custom-home-page #main{
      padding-top: 10px;
  }
}


.block_photo{
  min-height: 250px ; 
  width: 100%;
  padding: 20px;
  margin: 15px 0 ; 
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  position: relative ;
  h3{
    font-weight: 600;
    font-size: 1.4em;
    line-height: 120%;
    letter-spacing: -.05em;
    position: absolute ; 
    height: 50px;
    padding: 0px 0;
    bottom: 25px;
  }
  a.read_more{
    position: absolute;
    bottom: 10px;
    /* max-width: 100%; */
    display: block;
    /* text-align: right; */
    right: 20px;
    font-size: 1em;
  }
}

.iarc_layout{

  #header-menu{
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  }

  img.gco_logo{
    max-height: 70px; 
    margin-right: 20px;
  }

  img.website-logo{
    max-height: 70px; 
  }

  /*a{
    i{
      color: $peach ;
    }
  }*/

  h1 {
      font-weight: 700;
      font-size: 60px;
      line-height: 100%;
      margin-top: 30px;
  }

  h2:not(.graph-title){
    font-size: 20px;
    line-height: 38px;
    font-weight: bold;
    text-transform: uppercase;
  }

  &.long-read {
    .header-bar {
        position: fixed;
        top: 0;
        background-color: white;
        opacity: 0.9;
        width: 100%;
        z-index: 10;
    }

    main{
      position: relative;
        top: 175px;
    }
  }

  .breadcrumb{
    display: none ;
  }

  .menu-item:not(.menu-item-mobile) a.router-link-active.router-link-exact-active,
  .menu-item:not(.menu-item-mobile) a.router-link-active{
    font-weight: 700!important;
    border-bottom: solid 2px #fff;
    /*color: #fff!important;*/
    opacity: 1!important;
  }

  main.no_tabs_menu{
    padding-top: 0px !important;
  }

  main#main{
    .entry-content{
      padding-bottom: 50px;
    }
  }

  .scrollable-tabs-nav{
    flex-wrap: nowrap;
    overflow: hidden;
    /* Might not be needed based on your styling */
    margin-bottom: -14px;
  }

  .nav-tabs .nav-link{
    font-size: 14px;
    font-weight: 700;
    &:hover{
      border: none ;
    }
  }

  article{
    min-height: 600px ; 
    position: relative ;
    background: #f4f6f7;
    padding: 25px ; 
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    .anchor{
      top: -200px;
    }

    img.illu{
      border: solid 2px #fff ; 
    }
  }

  table.table{
    font-size: .9em;
  }

  table.table-striped{
    line-height: 1;
    border-color: #cccccc;
  }

  .anchor{

  }

  .bloc_sub_container{
    .tab_downloads_sub_block h3{
      color: $peach ;
    }
  }

  form {
    fieldset {
      h4{
        a.container_fieldset_icon{
          i{
            color: $peach ;
          }
        }
        a{
          color: $peach ;
        }
      }
      &.container_switcher_circle_pop{
        i{
          color: $peach ;
        }
      }
    }
    label.sort_icon {
      input:checked + i{
        border: solid 2px $peach;
      }
      &:hover{
        i{
          background-color: $peach ; 
        }
      }
    }
  }

  /* graphic */
  .page.dataviz.scrolling{
    
    #container-sub-menu,.tabs.dataviz-tabs{
      margin-top: 0px !important; 
    }

    #container-filters{
      top: 0px!important;
    }
  }

  .table-responsive{
    table{
      font-family: $font_family!important;
      th,td{
        font-family: $font_family!important;
      }
    } 
  }

  table.datatable{
    tr{
      th{
        font-family: $font_family!important;
        font-weight: 500;
        padding: 8px 8px;
      }
      td{
        font-family: $font_family!important;
        font-weight: 400;
      }
    }
  }

  /* table (dataviz) */
  table.table-dataset{
    
    thead{
      th{
        text-align: right ; 
        a{
          color: #000 ; 
        }
      }
    }
    tbody{
      td{
        text-align: right ; 
      }
    }
  }

  .icon-desc{
    font-family: $font_family !important ; 
  }

  .container-anchor{
    position: relative ;
    .anchor{
      position: absolute;
      top: -220px ;
    }
  }

}


/* import common css app */

// specific to Cancer Tomorrow
body{

  #app{

    header#header{ 
      background-image: url('./assets/img/iacr-header-2022.png') !important;
      background-repeat: no-repeat;
      background-size: 100%!important; 
      background-color: #fff,!important ;
      padding: 0 !important;
      .header-container{
        padding-bottom: 0;
        .header-top{
          padding-top: 25px;
          padding-bottom: 0 
        }
      }
      .header-menu .main-menu{
        padding-left: 100px;
      }
      .header-bg{
        background-color: transparent !important ; 
        .header-lang .btn-newsletter, .header-lang .btn-donations-custom{
          opacity: 1!important;
        }
        img#logo-iacr{
          max-height: 70px;
          margin-bottom: 20px;
        }
      }
    }

    /*label[for="nb_items_5"]{
      display: none !important ; 
    }
    #container-filters .filters .container_items .radios_toggle.radios_toggle_item5 label{
      width: 25%!important ;
    }
    */

    .container.innner{
      margin-top: 60px ;
    }

    

    footer{
      background: #2B3256 !important ; 
      &#footer{
        .footer-menu .menu-item,
        .footer-top .footer-top-content-text{
          text-align: left ; 
        }
      }
    }

    .footer-top{
      min-height: 60px;
    }
  }

  a{
    text-decoration: none; 
  }
  
  .container-anchor{
    position: relative ;
    .anchor{
      position: absolute;
      top: -180px ;
    }
  }

  #bar-container{
    min-height: 850px; 
    padding-bottom: 50px ;

    svg{
      display: block ; 
      margin:auto ;

      /*rect.bar,rect.bar_right,rect.swatch{
        stroke: #000;
        stroke-width:0.5px;
      }*/
      
      .tick{
        text{
          font-size: 1.4em;
        }
      }

      text.legend{
        font-size: 0.9em;
        font-weight: bolder;
      }

      text.bar_txt {
        font-size: 0.8em;
      }
    }
  }

  #container-filters{

    fieldset.container_snippet_volume_all,fieldset.container_snippet_volume_plus{
      opacity: 0 ; 
      height: 0 ; 
      div.all_volumes,div.ci5plus_volumes{
        background-color: #fff ; 
        padding: 10px 10px ;
        border: 1px solid #ccc;
        font-size: .9em ; 
        img{
          max-height: 50px;
        }
        h3{
          margin-top: 5px ; 
          display: inline-block ; 
          padding: 0 0 0 10px;
          vertical-align: top ; 
          color: #35495e ; 
          font-size: 1em;
          span{
            display: block; 
            width: 100%;
            padding-top: 5px;
          }
        }
      }

    }

  }
  
  table.totals{
    position: absolute ;
    bottom: 100px ; 
    left: 15px; 
    background: #f5f5f5 ; 
    transition: all 0.2s ease-in-out;
    width: auto;
    th,td{
      font-size: 0.8em;
      padding: 2px 8px ;
    }
    thead{
      background: #ccc ; 
      color: #000 ; 
      th{
        font-weight: 800 ; 
        text-align: right ; 
        border: solid 1px #ccc ; 
      }
    }
    tr{
      td{
        border: solid 1px #ccc ; 
        &.metric{
          font-weight: 700 ; 
          text-align: left ; 
        }
        &.value{
          text-align: right ; 
          font-weight: 500 ; 
        }
      } 
    }
  }

  .dataviz{
    .footnote{
      font-size: 12px;
      bottom: 58px;
      &.regional{
        bottom: 70px; 
      }
    }
    .footnote1{
      bottom: 75px;
    }
  }

  table.datatable{
    tr{
      th{
        font-size: 10pt;
      }
    }
    tr.group{
      background: #ccc ;
    }
  }

  div.dt-container{
    
    margin-bottom: 50px ;
    background: #fff;
    padding: 10px;

    div.dt-layout-row{
      margin: 0px 0 ;
      font-size: .9em ;
      margin: 5px 0 ; 
    }

    .dt-search input{
      max-width: 150px;
      border: 1px solid #ccc;
      max-height: 25px ;
    }

    select, input{
      margin: 0 2px
    }
  }

  table.dataTable thead th, 
  table.dataTable thead td, 
  table.dataTable tfoot th, 
  table.dataTable tfoot td{
    text-align: right ; 
  }

  #copyright-container{
    height: 0 ; 
    #copyright{
      bottom: 5px;
      line-height: 14px;
      #copyright-map ul li, #copyright ul li {
        list-style-type: none;
        line-height: 14px;
      }
    }
  }

  #trend-container .footnote.regional {
    bottom: 85px!important;
  }

  .footnote{
    span{
      display:inline;
      padding-left: 5px;
      font-style: italic;
      font-size: 1.2em;
    }
  }

  .footnote_apc{
    font-size: .7em;
    font-style: italic;
    text-align: left;
    padding: 10px 15px;
  }
}

body:not(.search):not(.error404):not(.about-iarc-contact-us):not(.mediacentrecontact):not(.nous-contacter) #main{
  background-image: none ; 
}

html.dataviz{
  div#container-filters{
    .container_types{
      /*label{
        width: 50% ;
      }
      label[for="input_inc_mort"]{
        display: none !important;
      }*/
    }
  }
}

.burger {
  background-image: url("./assets/img/burger.white.svg") !important;
}

.burger-logo{
  a#website_mobile_logo_iarc{
    display: block; 
    margin: auto ; 
    img{
      max-height: 100px ; 
      display: block ; 
      margin: auto ;
    }
  }
}


@media (max-width: 991px){

  #home{
    .home_dtviz_f{
      .container_h{

      }
    }
  }

  body #app header#header{
    background-size:200% !important;
  }

  .custom-home-page main#main{
    top: 40px ;
  }

  .burger{
    margin-top: -20px;
    width: 44px ; 
  }

  #main.home_iacr {
    .home_landing .inner h1{
      padding-top: 100px !important;
      font-size: 1.4em !important;
      width: 100%;
      display: block;
    } 
    .home_landing{
      background-position: center center ; 
      min-height: 400px !important;
    }

    .inner{
      max-width: 100% !important;
    }
  }
}

@media (min-width: 768px) and  (max-width: 992px) {

  .block_photo{
    min-height: 320px ; 
  }

}

form {
  
  /*fieldset{
    margin: 7px 0 !important; 
  }*/

  fieldset.container_selection label.group_selection .state label{
    margin-left: -130px!important;
  }
}

p{
  margin-bottom: 25px!important;
}

</style>